/**
 * @file Purchase Ppd Checkout.
 */

import React from 'react';

import PurchasePpdCheckoutContainer from '../../containers/purchase/PurchasePpdCheckoutContainer';

const PurchasePpdCheckoutView = () => <PurchasePpdCheckoutContainer />;

export default PurchasePpdCheckoutView;
